import { Checkbox, styled } from '@mui/material';

export const DisabledLocationCheckbox = styled(Checkbox)(({ theme }) => ({
  padding: 0,
  '&.Mui-disabled, &.Mui-disabled .MuiSvgIcon-root': {
    color: theme.colorPalette.primary.action.disabled,
  },
}));
